import React from 'react';
import PropTypes from "prop-types";
import Table from "../../../../common/components/Table/Table";
import {Button, Checkbox, Confirm, Popup} from "semantic-ui-react";
import KYCListRow from "./KYCListRow";
import {
    generatePDFReport,
    generateXLSReport,
} from "../../../../report-generation/veritas-report-gen/ReportGeneratorActions";
import {connect} from "react-redux";
import {
    kycTableSearch,
    selectAllKYC,
    setKYCServicesFilter,
    toggleKYCSort,
    updateKYCFilters
} from "../../actions/ServicesActions";
import {SortFields} from "../../constants/ServiceActionConstants";
import {Filter} from "../../../../common/components/Filter";
import {TableSearch} from "../../../../common/components/TableSearch";

export class KYCServicesTable extends React.Component {

    state = {
       selectCountryWarning: false
    }

    static propTypes = {
        KYCServices: PropTypes.array,
    }


    handleSort = (sortKey) => {
        this.props.changeKYCSort(sortKey);
    }

    getIsServiceSelected = (serviceId) => {
        return this.props.selected_kyc_services.includes(serviceId);
    }

    handleCheckboxSelect = (e, {checked}) => {
        const serviceIds = this.props.filtered_kyc_services.map(service => {
            return service.service_id
        });
        this.props.selectAllKYC(serviceIds, checked);
    };

    handleXLSReportClick = () => {
        const {selected_kyc_services, filters} = this.props;
        const countryCodes = filters.countryFilter.map(x => x.value);
        const countryCodesStr = countryCodes.join(',')
        const formattedIds = selected_kyc_services.join(',');
        if (countryCodesStr === "") {
            this.setState(prevState => ({
                selectCountryWarning: true
            }));
        } else {
            this.props.generateKYCXLSReport('external', formattedIds, countryCodesStr, "kyc");
        }
    };

    handleInternalXLSReportClick = () => {
        const {selected_kyc_services, filters} = this.props;
        const countryCodes = filters.countryFilter.map(x => x.value);
        const countryCodesStr = countryCodes.join(',')
        const formattedIds = selected_kyc_services.join(',');
        if (countryCodesStr === "") {
            this.setState(prevState => ({
                selectCountryWarning: true
            }));
        } else {
            this.props.generateKYCXLSReport('internal', formattedIds, countryCodesStr, "kyc");
        }
    };

    handlePDFReportClick = () => {
        const {selected_kyc_services, filters} = this.props;
        const countryCodes = filters.countryFilter.map(x => x.value);
        const countryCodesStr = countryCodes.join(',')
        const formattedIds = selected_kyc_services.join(',');
        if (countryCodesStr === "") {
            this.setState(prevState => ({
                selectCountryWarning: true
            }));
        } else {
            this.props.generateKYCPDFReport(formattedIds, countryCodesStr, 'kyc');
        }
    };

    handleSelectCountryWarning = () => {
        this.setState(prevState => ({
            selectCountryWarning: false
        }));
    }

    handleCountryFilter = (filterOption) => {
        this.props.setKYCServicesFilter(filterOption, "country");
        this.props.updateKYCFilter();
    }

    handleKYCTableSearch = (e) => {
        this.props.typeAheadSearchKYC(e.target.value);
    }

    get tableHeaders() {
        const headers = [
            <Table.Header key="checkbox">
                <Checkbox
                    checked={this.props.all_kyc_selected}
                    onChange={this.handleCheckboxSelect}
                />
            </Table.Header>,
            <Table.Header key="approved"> </Table.Header>,
            <Table.Header key="name" sortKey={SortFields.SERVICE_NAME}>Name</Table.Header>,
            <Table.Header key="country" className={"filterable-header"}>
                <div className={"header-text"} >Country</div>
                <Filter
                    isIcon
                    isMulti
                    placeholder="Country"
                    handleFilter={this.handleCountryFilter}
                    options={this.props.filterOptions.countryOptions}
                    value={this.props.filters.countryFilter}
                />
            </Table.Header>,
            <Table.Header key="source-types">Source Type(s)</Table.Header>,
            <Table.Header key="integration_status" sortKey={SortFields.STATUS}>Status</Table.Header>,
            <Table.Header key="updated" sortKey={SortFields.LAST_UPDATED}>Last Updated</Table.Header>,
        ];
        return headers.filter(header => header !== null);
    }

    get tableItems() {
        return this.props.KYCServices.map(service => (
            <KYCListRow
                key={service.service_id}
                serviceID={service.service_id}
                serviceName={service.service_name}
                serviceConfigName={service.primary_service_config_name}
                dataProviderName={service.provider_name}
                isApproved={service.is_approved}
                associatedCountries={service.associated_countries}
                currency={service.currency}
                perUnitCost={service.cost}
                pricingModel={service.price_model}
                status={service.integration_status}
                sourceTypes={service.source_types_with_identifiers}
                isSelected={this.getIsServiceSelected(service.service_id)}
                lastUpdated={service.last_updated}
            />
        ));
    }

    render() {
        return (
            <div>
                <div style={{padding: "20px 20px 0 30px"}}>
                    <Popup
                        content={"Generate PDF Report"}
                        trigger={
                            <Button
                            disabled={!this.props.all_kyc_selected && !this.props.some_kyc_selected }
                            icon="file pdf outline" size="big"
                            onClick={this.handlePDFReportClick}
                            />
                        }
                    />
                    <Popup
                        content={"Generate External-Use Source Report"}
                        trigger={
                            <Button
                                icon="file excel outline" size="big"
                                disabled={!this.props.all_kyc_selected && !this.props.some_kyc_selected}
                                onClick={this.handleXLSReportClick}
                            />
                        }
                    />
                    {
                        this.props.isDPEditor ? (
                            <Popup
                                content={"Generate Internal-Only Source Report"}
                                trigger={
                                    <Button
                                        icon="file excel outline" size="big"
                                        disabled={!this.props.all_kyc_selected && !this.props.some_kyc_selected}
                                        onClick={this.handleInternalXLSReportClick}
                                    />
                                }
                            />
                        ) : null
                    }
                </div>
                <div className="data-services-list-container">
                    <TableSearch
                        handleSearch={this.handleKYCTableSearch}
                    />
                    <div className="sticky-table-container">
                        <Table
                            className="sticky-table sortable"
                            currSortKey={this.props.kycSortKey}
                            sortDirection={this.props.kycSortDirection}
                            headers={this.tableHeaders}
                            onSort={this.handleSort}
                        >
                            {this.tableItems}
                        </Table>
                    </div>
                </div>

                <Confirm
                    open={this.state.selectCountryWarning}
                    content={
                        "In order to generate any report, you have to select the countries in the filter. " +
                        "A report of the sources in those selected countries will be generated. " +
                        "If you want to generate a report of all the sources used by that service, " +
                        "please select `ALL` as the value in the country filter."
                    }
                    onConfirm={this.handleSelectCountryWarning}
                    onCancel={this.handleSelectCountryWarning}
                />

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    all_kyc_selected: state.veritas.services.all_kyc_selected,
    selected_kyc_services:state.veritas.services.selected_kyc_services,
    filtered_kyc_services: state.veritas.services.filtered_kyc_services,
    kycSortKey: state.veritas.services.kycSortKey,
    kycSortDirection: state.veritas.services.kycSortDirection,
    some_kyc_selected: state.veritas.services.some_kyc_selected,
    filterOptions: state.veritas.services.filterOptions,
    filters: state.veritas.services.filters,
    isDPEditor: state.marvel.user.access.accessLevel.isDPEditor,
});

const mapDispatchToProps = dispatch => ({
    selectAllKYC: (serviceIds, isSelected) => {dispatch(selectAllKYC(serviceIds, isSelected))},
    generateKYCXLSReport: (reportType, selectedServices, countryCodes, serviceType) => {
        dispatch(generateXLSReport(reportType, selectedServices, countryCodes, serviceType))
    },
    generateKYCPDFReport: (selectedIds, countryCode, serviceType) => {
        dispatch(generatePDFReport(selectedIds, countryCode, serviceType))
    },
    changeKYCSort: (sortKey) => {dispatch(toggleKYCSort(sortKey))},
    setKYCServicesFilter: (filterOption, type) => {dispatch(setKYCServicesFilter(filterOption, type))},
    updateKYCFilter: () => {dispatch(updateKYCFilters())},

    typeAheadSearchKYC: (value) => {dispatch(kycTableSearch(value))}
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(KYCServicesTable)
